import * as tslib_1 from "tslib";
export function overrideFetch() {
    var _this = this;
    var oldFetch = window.fetch;
    window.fetch = function (input, init) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
        var href, requestInit, response;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    href = input['url'] || input['href'] || input;
                    if (!!/.*\.ltur\..*\/core/gm.test(href)) return [3 /*break*/, 2];
                    return [4 /*yield*/, oldFetch(input, init)];
                case 1: return [2 /*return*/, _a.sent()];
                case 2:
                    requestInit = init || { headers: new Headers() };
                    if (!requestInit.headers) {
                        requestInit.headers = new Headers();
                    }
                    requestInit.headers['X-JWT-MODE'] = 'web';
                    if (window.localStorage.getItem('XSRF-TOKEN')) {
                        requestInit.headers['X-XSRF-TOKEN'] = window.localStorage.getItem('XSRF-TOKEN');
                    }
                    return [4 /*yield*/, oldFetch(input, requestInit)];
                case 3:
                    response = _a.sent();
                    if (response.headers.has('XSRF-TOKEN')) {
                        window.localStorage.setItem('XSRF-TOKEN', response.headers.get('XSRF-TOKEN'));
                    }
                    return [2 /*return*/, response];
            }
        });
    }); };
}
